module.exports = __webpack_public_path__ + "img/CarThemePavilion_en.8243788b.png";